import { render, staticRenderFns } from "./Alibaba-buyer-add.vue?vue&type=template&id=1a0a9292&scoped=true&"
import script from "./Alibaba-buyer-add.vue?vue&type=script&lang=js&"
export * from "./Alibaba-buyer-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a9292",
  null
  
)

export default component.exports